import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Badge, Table, Modal } from 'react-bootstrap';
import { 
  FaRobot,
  FaPaperPlane,
  FaStar,
  FaUsers,
  FaMoneyBillWave,
  FaMapMarkerAlt,
  FaPalette,
  FaBuilding,
  FaImage,
  FaUtensils,
  FaCamera,
  FaLightbulb,
  FaSave,
  FaEye,
  FaTrash,
  FaPlus,
  FaCheckCircle,
  FaHeart,
  FaMusic,
  FaVideo
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import '../../../../assets/css/customer/dashboard/AIPlannar.css';
import CustomerLayout from '../../../../layouts/customer/CustomerLayout';
const AIPlanner = () => {

  // Packages Data with images
  const [packages] = useState([
    {
      id: 1,
      name: 'Gold Package',
      price: 2800000,
      badge: 'VIEW ALL',
      features: ['Luxury Decor', 'Full Catering', 'Photography'],
      image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=500&q=80',
      color: 'gold',
      btnColor: 'pink'
    },
    {
      id: 2,
      name: 'Silver Package',
      price: 1850000,
      features: ['Stylish Decor', 'Limited Catering', 'Basic Photography'],
      image: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=500&q=80',
      color: 'silver',
      btnColor: 'purple'
    },
    {
      id: 3,
      name: 'Diamond Package',
      price: 3500000,
      features: ['Premium Everything', 'Royal Treatment'],
      image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=500&q=80',
      color: 'diamond',
      btnColor: 'pink'
    },
    {
      id: 4,
      name: 'Budget Package',
      price: 1275000,
      features: ['Best Value', 'Economical Plan'],
      image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=500&q=80',
      color: 'budget',
      btnColor: 'pink'
    }
  ]);

  // Venues Database for AI Recommendations
  const [venues] = useState([
    {
      id: 1,
      name: 'Pearl Continental Hotel',
      city: 'Karachi',
      capacity: 500,
      priceRange: 'PKR25-35 Lakh',
      rating: 4.8,
      image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80',
      features: ['Grand Ballroom', '5-Star Service', 'Premium Catering', 'Valet Parking']
    },
    {
      id: 2,
      name: 'Royal Marquee',
      city: 'Lahore',
      capacity: 400,
      priceRange: 'Pkr18-25 Lakh',
      rating: 4.6,
      image: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=600&q=80',
      features: ['Garden Setup', 'Outdoor Venue', 'Natural Ambiance', 'Free Parking']
    },
    {
      id: 3,
      name: 'Dream Palace',
      city: 'Islamabad',
      capacity: 600,
      priceRange: 'PKR30-45 Lakh',
      rating: 4.9,
      image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=600&q=80',
      features: ['Royal Architecture', 'Crystal Chandeliers', 'VIP Lounge', 'Premium Services']
    },
    {
      id: 4,
      name: 'Garden Marquee',
      city: 'Lahore',
      capacity: 300,
      priceRange: 'PKR12-18 Lakh',
      rating: 4.4,
      image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&q=80',
      features: ['Budget-Friendly', 'Simple Elegant', 'Good Catering', 'Easy Access']
    },
    {
      id: 5,
      name: 'Elite Banquet Hall',
      city: 'Karachi',
      capacity: 450,
      priceRange: 'PKR20-28 Lakh',
      rating: 4.7,
      image: 'https://images.unsplash.com/photo-1519167758481-83f29da8c0c4?w=600&q=80',
      features: ['Modern Design', 'LED Lighting', 'Premium Sound System', 'AC Hall']
    }
  ]);

  // Services for recommendation
  const [services] = useState([
    { id: 1, name: 'Floral Decorations', icon: '🌸', selected: true },
    { id: 2, name: 'Premium Catering', icon: '🍽️', selected: true, note: '(3 Dishes)' },
    { id: 3, name: 'Stage & Lighting', icon: '💡', selected: true, tip: 'Remove Fireworks + Save 15 Lakh' },
    { id: 4, name: 'Photography + Video', icon: '📸', selected: true },
    { id: 5, name: 'DJ & Music', icon: '🎵', selected: true }
  ]);

  // Chat Messages
  const [chatMessages, setChatMessages] = useState([
    {
      id: 1,
      sender: 'ai',
      text: "Hello! 👋 I'm your AI Wedding Planner.\n\nI can help you find the perfect venue and package for your special day! 🎉\n\nTell me about your event, and I'll recommend the best options for you.",
      timestamp: new Date().toLocaleTimeString()
    }
  ]);

  // Recommendation
  const [recommendation, setRecommendation] = useState({
    venue: 'Royal Grand Palace',
    estimatedCost: 2350000,
    withinBudget: true,
    image: 'https://images.unsplash.com/photo-1519167758481-83f29da8c0c4?w=600&q=80'
  });

  // Saved Plans
  const [savedPlans, setSavedPlans] = useState([
    {
      id: 1,
      eventType: 'Mehndi + Barat',
      guests: 350,
      budget: 2500000,
      estimatedCost: 2350000,
      matchingPackage: 'Royal Grand Palace - Gold Package',
      createdAt: '2026-03-01'
    },
    {
      id: 2,
      eventType: 'Walima',
      guests: 200,
      budget: 2000000,
      estimatedCost: 1875000,
      matchingPackage: 'Garden Marquee - Silver Package',
      createdAt: '2026-03-02'
    },
    {
      id: 3,
      eventType: 'Full Wedding',
      guests: 500,
      budget: 4000000,
      estimatedCost: 3820000,
      matchingPackage: 'Dream Palace - Diamond Package',
      createdAt: '2026-03-03'
    },
    {
      id: 4,
      eventType: 'Mehndi',
      guests: 250,
      budget: 1500000,
      estimatedCost: 1480000,
      matchingPackage: 'Rose Garden - Budget Package',
      createdAt: '2026-03-04'
    }
  ]);

  // Form State
  const [userMessage, setUserMessage] = useState('');
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const chatEndRef = useRef(null);

  // Scroll to bottom
  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Handle Send Message
  const handleSendMessage = (e) => {
    e.preventDefault();
    
    if (!userMessage.trim()) return;

    const newMessage = {
      id: chatMessages.length + 1,
      sender: 'user',
      text: userMessage,
      timestamp: new Date().toLocaleTimeString()
    };

    setChatMessages([...chatMessages, newMessage]);
    const userInput = userMessage.toLowerCase();
    setUserMessage('');

    // Simulate AI response with package and venue recommendations
    setTimeout(() => {
      let aiResponseText = '';
      let recommendedPackage = null;
      let recommendedVenue = '';
      
      // Determine package based on keywords
      if (userInput.includes('luxury') || userInput.includes('premium') || userInput.includes('gold')) {
        recommendedPackage = packages[0]; // Gold Package
        recommendedVenue = 'Pearl Continental Hotel';
        aiResponseText = "Perfect! Based on your preference for luxury, I recommend:\n\n🏆 Gold Package (₹28,00,000)\n✓ Luxury Decor\n✓ Full Catering\n✓ Professional Photography\n\n🏛️ Venue: Pearl Continental Hotel\nCapacity: 500 guests\nLocation: Karachi\n\nThis is our premium option with the finest amenities!";
      } else if (userInput.includes('diamond') || userInput.includes('royal') || userInput.includes('best')) {
        recommendedPackage = packages[2]; // Diamond Package
        recommendedVenue = 'Dream Palace';
        aiResponseText = "Excellent choice! For a royal experience, I suggest:\n\n💎 Diamond Package (₹35,00,000)\n✓ Premium Everything\n✓ Royal Treatment\n✓ Exclusive Services\n\n🏛️ Venue: Dream Palace\nCapacity: 600 guests\nLocation: Islamabad\n\nOur most luxurious option for an unforgettable event!";
      } else if (userInput.includes('budget') || userInput.includes('affordable') || userInput.includes('cheap')) {
        recommendedPackage = packages[3]; // Budget Package
        recommendedVenue = 'Rose Garden Banquet';
        aiResponseText = "Great! For a budget-friendly yet elegant option:\n\n💰 Budget Package (₹12,75,000)\n✓ Best Value\n✓ Economical Plan\n✓ Quality Services\n\n🏛️ Venue: Rose Garden Banquet\nCapacity: 250 guests\nLocation: Lahore\n\nPerfect balance of quality and affordability!";
      } else if (userInput.includes('silver') || userInput.includes('medium') || userInput.includes('standard')) {
        recommendedPackage = packages[1]; // Silver Package
        recommendedVenue = 'Royal Marquee';
        aiResponseText = "Wonderful! I recommend our popular choice:\n\n⭐ Silver Package (₹18,50,000)\n✓ Stylish Decor\n✓ Limited Catering\n✓ Basic Photography\n\n🏛️ Venue: Royal Marquee\nCapacity: 350 guests\nLocation: Lahore\n\nOur most balanced option with great value!";
      } else {
        // Default recommendation
        recommendedPackage = packages[1]; // Silver Package
        recommendedVenue = 'Royal Marquee';
        aiResponseText = "Thank you for your message! Based on your requirements, I suggest:\n\n⭐ Silver Package (₹18,50,000)\n✓ Stylish Decor\n✓ Limited Catering\n✓ Basic Photography\n\n🏛️ Venue: Royal Marquee\nCapacity: 350 guests\n\nWould you like to see more options? Try keywords like:\n• 'luxury' or 'gold' for premium\n• 'diamond' for royal experience\n• 'budget' for affordable options";
      }

      const aiResponse = {
        id: chatMessages.length + 2,
        sender: 'ai',
        text: aiResponseText,
        timestamp: new Date().toLocaleTimeString()
      };
      setChatMessages(prev => [...prev, aiResponse]);

      // Update recommendation if package was selected
      if (recommendedPackage) {
        setTimeout(() => {
          const newRecommendation = {
            venue: recommendedVenue,
            estimatedCost: Math.floor(recommendedPackage.price * 0.94),
            withinBudget: true,
            image: recommendedPackage.image
          };
          setRecommendation(newRecommendation);

          const recMessage = {
            id: chatMessages.length + 3,
            sender: 'ai',
            text: `I've prepared a detailed recommendation for you! Check it out below 👇`,
            timestamp: new Date().toLocaleTimeString()
          };
          setChatMessages(prev => [...prev, recMessage]);
        }, 1500);
      }
    }, 1000);
  };

  // Save Recommendation
  const handleSaveRecommendation = () => {
    Swal.fire({
      icon: 'success',
      title: 'Recommendation Saved!',
      text: 'Your wedding plan has been saved successfully',
      confirmButtonColor: '#e91e63',
      timer: 2000,
      showConfirmButton: false
    });
  };

  // Keep Plan
  const handleKeepPlan = () => {
    Swal.fire({
      icon: 'success',
      title: 'Plan Kept!',
      confirmButtonColor: '#4caf50',
      timer: 1500,
      showConfirmButton: false
    });
  };

  // Modify Plan
  const handleModifyPlan = () => {
    Swal.fire({
      icon: 'info',
      title: 'Modify Plan',
      text: 'Please update your preferences and regenerate',
      confirmButtonColor: '#ff9800'
    });
  };

  // Select Package - Shows AI response and generates plan
  const handleSelectPackage = (pkg) => {
    // Add AI message showing package selection
    const aiMessage = {
      id: chatMessages.length + 1,
      sender: 'ai',
      text: `Excellent choice! You've selected the ${pkg.name}! 🎉\n\nHere's what's included:\n${pkg.features.map(f => '✓ ' + f).join('\n')}\n\nLet me prepare your personalized plan...`,
      timestamp: new Date().toLocaleTimeString()
    };

    setChatMessages([...chatMessages, aiMessage]);

    // Show success alert
    Swal.fire({
      icon: 'success',
      title: `${pkg.name} Selected!`,
      html: `<div style="text-align: left; padding: 10px;">
        <h4 style="color: #e91e63; margin-bottom: 10px;">Package Details:</h4>
        <p><strong>Price:</strong> ₹${pkg.price.toLocaleString()}</p>
        <p><strong>Features:</strong></p>
        <ul style="margin-left: 20px;">
          ${pkg.features.map(f => `<li>${f}</li>`).join('')}
        </ul>
        <p style="color: #4caf50; font-weight: bold; margin-top: 15px;">✓ AI is preparing your plan!</p>
      </div>`,
      confirmButtonColor: '#e91e63',
      confirmButtonText: 'Great!',
      timer: 3000
    });

    // Generate recommendation after delay
    setTimeout(() => {
      const newRecommendation = {
        venue: pkg.name === 'Gold Package' ? 'Pearl Continental' : 
                pkg.name === 'Silver Package' ? 'Royal Marquee' :
                pkg.name === 'Diamond Package' ? 'Dream Palace' : 'Rose Garden',
        estimatedCost: Math.floor(pkg.price * 0.94),
        withinBudget: true,
        image: 'https://images.unsplash.com/photo-1519167758481-83f29da8c0c4?w=600&q=80'
      };

      setRecommendation(newRecommendation);

      // Add recommendation message
      const recMessage = {
        id: chatMessages.length + 2,
        sender: 'ai',
        text: `Perfect! I've prepared a customized plan for you based on the ${pkg.name}. Check the recommendation section below! 👇`,
        timestamp: new Date().toLocaleTimeString()
      };

      setChatMessages(prev => [...prev, recMessage]);
    }, 2000);
  };

  // View Plan
  const handleViewPlan = (plan) => {
    setSelectedPlan(plan);
    setShowViewModal(true);
  };

  // Delete Plan
  const handleDeletePlan = (planId) => {
    Swal.fire({
      title: 'Delete Plan?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#9e9e9e',
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        setSavedPlans(savedPlans.filter(plan => plan.id !== planId));
        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          confirmButtonColor: '#4caf50',
          timer: 1500,
          showConfirmButton: false
        });
      }
    });
  };

  // New Chat
  const handleNewChat = () => {
    setChatMessages([
      {
        id: 1,
        sender: 'ai',
        text: "Hello! 👋 I'm your AI Wedding Planner.\n\nI can help you find the perfect venue and package for your special day! 🎉\n\nTell me about your event, and I'll recommend the best options for you.",
        timestamp: new Date().toLocaleTimeString()
      }
    ]);
    
    Swal.fire({
      icon: 'success',
      title: 'New Chat Started!',
      text: 'Ready to plan your perfect wedding',
      confirmButtonColor: '#e91e63',
      timer: 1500,
      showConfirmButton: false
    });
  };

  return (
    <CustomerLayout>
    <div className="aip-planner-page">
      {/* Decorative Background Elements */}
      <div className="aip-bg-decoration aip-flower-left"></div>
      <div className="aip-bg-decoration aip-flower-right"></div>
      <div className="aip-bg-decoration aip-couple-illustration"></div>

      <Container fluid className="aip-container">
        
        {/* Page Header */}
        <div className="aip-page-header">
          <div className="aip-header-decoration">🎊</div>
          <h1 className="aip-page-title">
            AI <span className="aip-title-wedding">Wedding</span> <span className="aip-title-planner">Planner</span>
          </h1>
          <p className="aip-page-subtitle">Your Smart Wedding Assistant</p>
          <div className="aip-header-decoration-right">💐</div>
          <div className="aip-header-icons">
            <Button className="aip-new-chat-header-btn" onClick={handleNewChat}>
              <FaPlus /> New Chat
            </Button>
            <span className="aip-header-icon">🔔</span>
            <span className="aip-header-icon">✉️</span>
            <img src="https://ui-avatars.com/api/?name=My+Account&background=e91e63&color=fff" alt="Account" className="aip-header-avatar" />
            <span className="aip-header-text">My Account</span>
          </div>
        </div>

        <Row className="aip-main-row">
          
          {/* Full Width - AI Chat, Recommendation & Saved Plans */}
          <Col lg={12} md={12} className="aip-left-col">
            
            {/* AI Chat Assistant */}
            <Card className="aip-chat-card">
              <Card.Header className="aip-chat-header">
                <div className="aip-chat-label">🤖 AI Chat Assistant</div>
              </Card.Header>
              <Card.Body className="aip-chat-body">
                
                {/* Chat Messages */}
                <div className="aip-chat-messages">
                  {chatMessages.map((message) => (
                    <div key={message.id} className={`aip-message ${message.sender === 'ai' ? 'aip-message-ai' : 'aip-message-user'}`}>
                      {message.sender === 'ai' && (
                        <div className="aip-ai-avatar">
                          <img src="https://ui-avatars.com/api/?name=Ayesha&background=e91e63&color=fff" alt="AI" />
                          <span className="aip-ai-badge">👤</span>
                        </div>
                      )}
                      <div className="aip-message-bubble">
                        <div className="aip-message-header">
                          {message.sender === 'ai' ? 'Hello Ayesha!' : 'You'}
                          {message.sender === 'ai' && ' 👋'}
                        </div>
                        <p className="aip-message-text">{message.text}</p>
                        {message.details && (
                          <div className="aip-message-details">
                            <div className="aip-detail-row">
                              <FaHeart className="aip-detail-icon" />
                              <span>Event Type: <strong>{message.details.eventType}</strong></span>
                            </div>
                            <div className="aip-detail-row">
                              <FaUsers className="aip-detail-icon" />
                              <span>Guests: <strong>{message.details.guests}</strong></span>
                            </div>
                            <div className="aip-detail-row">
                              <FaMoneyBillWave className="aip-detail-icon" />
                              <span>Budget: <strong>{message.details.budget}</strong></span>
                            </div>
                            <div className="aip-detail-row">
                              <FaMapMarkerAlt className="aip-detail-icon" />
                              <span>City: <strong>{message.details.city}</strong></span>
                            </div>
                            <div className="aip-detail-row">
                              <FaPalette className="aip-detail-icon" />
                              <span>Theme Style: <strong>{message.details.theme}</strong></span>
                            </div>
                          </div>
                        )}
                      </div>
                      {message.sender === 'user' && (
                        <div className="aip-user-avatar">
                          <img src="https://ui-avatars.com/api/?name=User&background=7fd3c1&color=fff" alt="User" />
                        </div>
                      )}
                    </div>
                  ))}
                  <div ref={chatEndRef} />
                </div>

                {/* User Input Message */}
                <div className="aip-user-input-section">
                  <div className="aip-user-message-box">
                    <div className="aip-user-avatar-small">
                      <img src="https://ui-avatars.com/api/?name=User&background=7fd3c1&color=fff" alt="User" />
                    </div>
                    <div className="aip-user-message-content">
                      <p>I want colorful theme with premium catering & photography under 25 Lakh</p>
                    </div>
                  </div>
                </div>

                {/* Message Input */}
                <Form onSubmit={handleSendMessage} className="aip-message-form">
                  <Form.Control
                    type="text"
                    placeholder="Type your request here..."
                    className="aip-message-input"
                    value={userMessage}
                    onChange={(e) => setUserMessage(e.target.value)}
                  />
                  <Button type="submit" className="aip-send-btn">
                    <FaPaperPlane /> Send
                  </Button>
                </Form>
              </Card.Body>
            </Card>

            {/* AI Recommendation */}
            <Card className="aip-recommendation-card">
              <Card.Header className="aip-rec-header">
                <div className="aip-ai-avatar-small">
                  <img src="https://ui-avatars.com/api/?name=AI&background=e91e63&color=fff" alt="AI" />
                </div>
                <div className="aip-rec-title-section">
                  <div className="aip-rec-title">Great! Here's my <strong>Recommendation</strong> for you:</div>
                </div>
              </Card.Header>
              <Card.Body className="aip-rec-body">
                <Row>
                  <Col md={5}>
                    <div className="aip-rec-left">
                      <div className="aip-venue-label">Venue: <strong>Royal Grand Palace</strong></div>
                      <img 
                        src={recommendation.image} 
                        alt="Venue"
                        className="aip-venue-image"
                      />
                      <div className="aip-services-selected">
                        <div className="aip-services-title">Services Selected:</div>
                        {services.map((service) => (
                          <div key={service.id} className="aip-service-item">
                            <FaCheckCircle className="aip-service-check" />
                            <span className="aip-service-icon">{service.icon}</span>
                            <span className="aip-service-name">{service.name}</span>
                            {service.note && <span className="aip-service-note">{service.note}</span>}
                            {service.tip && (
                              <div className="aip-service-tip">
                                💡 Tip: {service.tip}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>
                  <Col md={7}>
                    <div className="aip-rec-right">
                      <div className="aip-cost-section">
                        <div className="aip-cost-label">Estimated Cost: <strong className="aip-cost-value">₹23,50,000 PKR</strong></div>
                        <div className="aip-budget-check">
                          <FaCheckCircle className="aip-budget-icon" /> Within Your Budget!
                        </div>
                      </div>
                      <div className="aip-rec-actions">
                        <Button className="aip-btn-keep" onClick={handleKeepPlan}>
                          <FaCheckCircle /> Keep Plan
                        </Button>
                        <Button className="aip-btn-modify" onClick={handleModifyPlan}>
                          Modify Plan
                        </Button>
                      </div>
                      <Button className="aip-btn-save-rec" onClick={handleSaveRecommendation}>
                        <FaSave /> Save this Recommendation
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Saved Suggestions */}
            <Card className="aip-saved-card">
              <Card.Header className="aip-saved-header">
                <div className="aip-saved-title">
                  🎀 Saved Suggestions <span className="aip-saved-emoji">👰</span>
                </div>
                <div className="aip-saved-decoration">💐</div>
              </Card.Header>
              <Card.Body className="aip-saved-body">
                <div className="aip-table-wrapper">
                  <Table className="aip-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Event Types</th>
                        <th>Guests</th>
                        <th>Budget</th>
                        <th>Estimated Cost</th>
                        <th>Matching Package</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {savedPlans.map((plan, index) => (
                        <tr key={plan.id}>
                          <td className="aip-plan-id">{index + 1}</td>
                          <td className="aip-event-type">{plan.eventType}</td>
                          <td>{plan.guests}</td>
                          <td>{(plan.budget / 100000).toFixed(0)} Lakh</td>
                          <td className="aip-estimated-cost">
                            <FaStar className="aip-cost-star" />
                            {(plan.estimatedCost / 100000).toFixed(2).replace('.', ',')}
                          </td>
                          <td>
                            <div className="aip-package-cell">
                              <div className="aip-package-icon">🏛️</div>
                              <div className="aip-package-info">
                                <div className="aip-package-venue">{plan.matchingPackage.split(' - ')[0]}</div>
                                <Badge className="aip-package-badge">
                                  {plan.matchingPackage.split(' - ')[1]}
                                </Badge>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="aip-action-buttons">
                              <Button
                                size="sm"
                                className="aip-btn-view"
                                onClick={() => handleViewPlan(plan)}
                              >
                                <FaEye /> View
                              </Button>
                              <Button
                                size="sm"
                                className="aip-btn-delete"
                                onClick={() => handleDeletePlan(plan.id)}
                              >
                                <FaTrash /> Delete
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>

          </Col>
        </Row>

      </Container>

      {/* View Plan Modal */}
      {selectedPlan && (
        <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered className="aip-modal">
          <Modal.Header closeButton>
            <Modal.Title>📋 Plan Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="aip-modal-content">
              <p><strong>Event Type:</strong> {selectedPlan.eventType}</p>
              <p><strong>Guests:</strong> {selectedPlan.guests}</p>
              <p><strong>Budget:</strong> ₹{selectedPlan.budget.toLocaleString()}</p>
              <p><strong>Estimated Cost:</strong> ₹{selectedPlan.estimatedCost.toLocaleString()}</p>
              <p><strong>Package:</strong> {selectedPlan.matchingPackage}</p>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
    </CustomerLayout>
  );
};

export default AIPlanner;